import { isDefined } from "@clipboard-health/util-ts";
import { Button, Modal } from "antd";
import { useMemo, useState } from "react";

import { useGetProfileChangeLogs } from "./api/useGetProfileChangeLogs";
import { ProfileChangeLogsModalContent } from "./ProfileChangeLogsModalContent";

interface ProfileChangeLogsCardProps {
  id?: string;
}

export function ProfileChangeLogsCard({ id }: ProfileChangeLogsCardProps) {
  const [showLogs, setShowLogs] = useState(false);

  const { data, isLoading, isFetchingNextPage, isError, fetchNextPage, hasNextPage } =
    useGetProfileChangeLogs({ id: id ?? "" }, { enabled: showLogs && isDefined(id) });

  const logs = useMemo(() => data?.pages.flatMap((page) => page.logs) ?? [], [data]);

  if (!showLogs) {
    return <Button onClick={() => setShowLogs(true)}>Show Profile Change Logs</Button>;
  }

  return (
    <Modal
      title="Profile Changes"
      visible={showLogs}
      onCancel={() => setShowLogs(false)}
      width={1200}
      footer={null}
    >
      <ProfileChangeLogsModalContent
        isError={isError}
        isLoading={isLoading}
        isFetchingNextPage={isFetchingNextPage}
        hasNextPage={hasNextPage ?? false}
        logs={logs}
        onLoadMore={() => void fetchNextPage()}
      />
    </Modal>
  );
}
